const US_COUNTRIES = new Set([
  'us',
  'usa',
  'united states',
  'united states of america',
  'america',
]);

const CA_COUNTRIES = new Set(['ca', 'can', 'canada']);

const CA_PROVINCES = new Set([
  'ab', 'bc', 'mb', 'nb', 'nl', 'ns', 'nt', 'nu', 'on', 'pe', 'qc', 'sk', 'yt',
  'alberta', 'british columbia', 'manitoba', 'new brunswick',
  'newfoundland and labrador', 'newfoundland', 'nova scotia',
  'northwest territories', 'nunavut', 'ontario', 'prince edward island',
  'quebec', 'québec', 'saskatchewan', 'yukon',
]);

const US_STATES = new Set([
  'al', 'ak', 'az', 'ar', 'ca', 'co', 'ct', 'de', 'dc', 'fl', 'ga', 'hi', 'id', 'il', 'in', 'ia',
  'ks', 'ky', 'la', 'me', 'md', 'ma', 'mi', 'mn', 'ms', 'mo', 'mt', 'ne', 'nv', 'nh', 'nj', 'nm',
  'ny', 'nc', 'nd', 'oh', 'ok', 'or', 'pa', 'ri', 'sc', 'sd', 'tn', 'tx', 'ut', 'vt', 'va', 'wa',
  'wv', 'wi', 'wy',
  'alabama', 'alaska', 'arizona', 'arkansas', 'california', 'colorado', 'connecticut',
  'delaware', 'district of columbia', 'florida', 'georgia', 'hawaii', 'idaho', 'illinois',
  'indiana', 'iowa', 'kansas', 'kentucky', 'louisiana', 'maine', 'maryland', 'massachusetts',
  'michigan', 'minnesota', 'mississippi', 'missouri', 'montana', 'nebraska', 'nevada',
  'new hampshire', 'new jersey', 'new mexico', 'new york', 'north carolina', 'north dakota',
  'ohio', 'oklahoma', 'oregon', 'pennsylvania', 'rhode island', 'south carolina', 'south dakota',
  'tennessee', 'texas', 'utah', 'vermont', 'virginia', 'washington', 'west virginia',
  'wisconsin', 'wyoming',
]);

function normalizePlace(value: string | null | undefined): string {
  return (value || '').trim().toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
}

// Country wins when present; otherwise fall back to the state/province.
// A bare "CA" state is California, so it never counts as Canada.
export function isUnitedStatesProperty(
  country: string | null | undefined,
  state: string | null | undefined,
): boolean {
  const normalizedCountry = normalizePlace(country);
  if (normalizedCountry) return US_COUNTRIES.has(normalizedCountry);
  const normalizedState = normalizePlace(state);
  if (!normalizedState || CA_PROVINCES.has(normalizedState)) return false;
  return US_STATES.has(normalizedState);
}

export function isCanadianProperty(
  country: string | null | undefined,
  state: string | null | undefined,
): boolean {
  const normalizedCountry = normalizePlace(country);
  if (normalizedCountry) return CA_COUNTRIES.has(normalizedCountry);
  return CA_PROVINCES.has(normalizePlace(state));
}

/** "Neighborhood" → "Neighbourhood", "neighbors" → "neighbours", case preserved. */
export function toCanadianSpelling(text: string): string {
  return text.replace(/\b(neighb)(or)/gi, (_, stem: string, suffix: string) =>
    stem + (suffix === 'OR' ? 'OUR' : 'our'),
  );
}
